var map = {
	"./apple.svg": "d8a3",
	"./data_check_28dp_00366D.svg": "49c5",
	"./logo.svg": "9b19",
	"./playstore.svg": "5056",
	"./whatsapp.svg": "3357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";